import React from "react";
import { toRoundedNumber } from "@helpers";
import { PerformanceGauges } from "@features/performance";
import { useRecommendationDetails } from "../../RecommendationDetailsProvider";

export const PerformanceGaugeSection = () => {
  const { fundDetails } = useRecommendationDetails();
  if (!fundDetails) return null;

  const performanceClass = Math.round(fundDetails?.performanceClass ?? 0);
  const riskClass = Math.round(fundDetails?.riskClass ?? 0);

  const volatility = fundDetails?.riskStatistics
    ? `${toRoundedNumber(
        fundDetails?.riskStatistics?.volatilityOneYear ?? 0
      )}% / ${toRoundedNumber(
        fundDetails?.riskStatistics?.volatilityThreeYears ?? 0
      )}%`
    : "";

  return (
    <PerformanceGauges
      riskClass={riskClass}
      performanceClass={performanceClass}
      volatility={volatility}
      maximumClass={6}
    />
  );
};
